function init() {

  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
   *  REGEX
   * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var mobileNumberValidation = /^(\+98|0)\d{10}$/;
  var allnumber = /^\d+$/;
  var emailValidation = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;



  var $errMsg = $('.signin__err');


  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
   *  FUNCTIONS
   * * * * * * * * * * * * * * * * * * * * * * * * * * */

  // function that shows the error msg if there is an error
  function showErrMsg(el, msg) {
    $errMsg.text(msg).fadeIn();

    el.css({
      "box-shadow": "inset 0 0 20px red",
    });
    setTimeout(function () {
      $errMsg.fadeOut();
      el.css({
        "box-shadow": "none",
        "border": "none",
      });
    }, 5000);
  }


  // function to detect if an entry is not FARSI 
  function isArabic(strInput) {
    var arregex = /[\u0600-\u06FF]/;
    if (arregex.test(strInput)) {
      return true;
    } else {
      return false;
    }
  }


  // function to turn farsi numbers to english numbers
  function persianToEnglish(value) {
    var newValue = "";
    for (var i = 0; i < value.length; i++) {
      var ch = value.charCodeAt(i);
      if (ch >= 1776 && ch <= 1785) // For Persian digits.
      {
        var newChar = ch - 1728;
        newValue = newValue + String.fromCharCode(newChar);
      } else if (ch >= 1632 && ch <= 1641) // For Arabic & Unix digits.
      {
        var newChar = ch - 1584;
        newValue = newValue + String.fromCharCode(newChar);
      } else {
        newValue = newValue + String.fromCharCode(ch);
      }
    }

    return newValue;
  }




  /* * * * * * * * * * * * * * * * * * * * * * * * * * *
   *  FORM NAVIGATOPN - ROUTING - VALIDATION 
   * * * * * * * * * * * * * * * * * * * * * * * * * * */

  $('.letsSignUp').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.signin__form').addClass('signin__form--hidden');
    $(this).parents('.signin__form').siblings('.signupp').removeClass('signin__form--hidden');
  });

  $('.entr').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.signin__form').addClass('signin__form--hidden');
    $(this).parents('.signin__form').siblings('.enterr').removeClass('signin__form--hidden');
  });

  $('.losturpass').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.signin__form').addClass('signin__form--hidden');
    $(this).parents('.signin__form').siblings('.tellmepass').removeClass('signin__form--hidden');
  });


  $('.letsgetinside').on('click', function () {

    if ($('#username').val().length <= 0) {
      showErrMsg($('#username'), 'لطفا ایمیل یا شماره موبایل خود را وارد کنید');
      return false;
    }

    var userName = $('#username').val();

    // check to see if its arabic then transform it ino english    
    if(isArabic(userName)){            
      userName = persianToEnglish(userName);      
    }

    // check to see if its mobile or email
    if (allnumber.test(userName)) {

      // if it was all number check if its valid mobile number
      if (!mobileNumberValidation.test(userName)) {
        showErrMsg($('#username'), 'شماره موبایل وارد شده صحیح نمیباشد');
        return false;
      }
    } else {
      if (!emailValidation.test($('#username').val())) {
        showErrMsg($('#username'), 'ایمیل وارد شده صحیح نمیباشد');
        return false;
      }
    }

    if ($('#password').val().length <= 0) {
      showErrMsg($('#password'), 'لطفا رمز عبور خود را وارد کنید');
      return false;
    }

  });


  $('.goSignUp').on('click', function () {

    if ($('#mobileNum').val().length <= 0) {
      showErrMsg($('#mobileNum'), 'لطفا شماره موبایل خود را وارد کنید');
      return false;
    }

    var mobiNum = $('#mobileNum').val();

    // check to see if its arabic then transform it ino english    
    if(isArabic(mobiNum)){            
      mobiNum = persianToEnglish(mobiNum);      
    }

    // check to see if its mobile or email
    if (allnumber.test(mobiNum)) {
      // if it was all number check if its valid mobile number
      if (!mobileNumberValidation.test(mobiNum)) {
        showErrMsg($('#mobileNum'), 'شماره موبایل وارد شده صحیح نمیباشد');
        return false;
      }
    } else {
      showErrMsg($('#mobileNum'), 'شماره موبایل وارد شده صحیح نمیباشد');
      return false;
    }

    if ($('#firstPass').val().length <= 0) {
      showErrMsg($('#firstPass'), 'لطفا کلمه عبور مورد نظر خود را وارد کنید');
      return false;
    }

    if ($('#repeatPass').val().length <= 0) {
      showErrMsg($('#repeatPass'), 'لطفا کلمه عبور خود را تکرار کنید');
      return false;
    }

    if ($('#repeatPass').val() !== $('#firstPass').val()) {
      showErrMsg($('#repeatPass'), 'عدم تطابق تکرار با کلمه ی عبور وارد شده');
      return false;
    }

  });



}

$(function (e) {
  init();
});